<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Thêm mới sản phẩm</strong>
          </div>
          <b-form @submit.prevent="save">
            <b-row>
              <b-col>
                <b-form-group
                  label="Danh mục sản phẩm:"
                  label-for="categoryId"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                >
                  <!--<select2 class="no-padding col-10 " v-model="product.categoryId"
                                             v-if="categories.length > 0"
                                             :options="categories"
                                             allowClear="true"
                                             placeholder="--- Chọn ---"></select2>-->
                  <treeselect
                    :multiple="true"
                    class="col-10 no-padding"
                    v-if="categories.length > 0"
                    v-model="product.categoryIds"
                    placeholder="--- Chọn ---"
                    :options="categories"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Mã sản phẩm:"
                  label-for="code"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  label-class="required"
                >
                  <b-form-input
                    type="text"
                    id="code"
                    class="col-10"
                    aria-describedby="codeFeedback"
                    v-model="$v.product.code.$model"
                    :state="
                      $v.product.code.$dirty ? !$v.product.code.$error : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="codeFeedback">
                    Vui lòng nhập mã sản phẩm
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Tiêu đề sản phẩm:"
                  label-for="title"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  label-class="required"
                >
                  <b-form-input
                    type="text"
                    id="title"
                    class="col-10"
                    aria-describedby="codeFeedback"
                    v-model="$v.product.title.$model"
                    :state="
                      $v.product.title.$dirty ? !$v.product.title.$error : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="codeFeedback">
                    Vui lòng nhập tên sản phẩm
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Tên không dấu:"
                  label-for="slug"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                >
                  <b-form-input
                    type="text"
                    id="slug"
                    class="col-10"
                    aria-describedby="codeFeedback"
                    v-model="product.slug"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Mô tả:"
                  label-for="description"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  label-class="required"
                >
                  <b-form-textarea
                    id="description"
                    v-model="$v.product.description.$model"
                    :state="
                      $v.product.description.$model &&
                      $v.product.description.$dirty
                        ? !$v.product.description.$error
                        : null
                    "
                    class="col-10"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback id="codeFeedback">
                    Vui lòng nhập tên sản phẩm
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- <div class="row">
              <b-col md="12">
                <b-form-group
                  label="Chi tiết:"
                  label-for="detail"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  label-class="required"
                  content-cols="10"
                  id="editor-css"
                >
                  <div class="col-md-10 no-padding">
                    <b-form-input
                      type="text"
                      style="display: none"
                      aria-describedby="codeFeedback"
                      v-model="$v.product.detail.$model"
                      :state="
                        $v.product.detail.$dirty
                          ? !$v.product.detail.$error
                          : null
                      "
                    >
                    </b-form-input>
                    <DocumentEditor
                      ref="doc"
                      v-model="product.detail"
                    ></DocumentEditor>
                    <b-form-invalid-feedback v-if="!$v.product.detail.required">
                      Vui lòng nhập chi tiết !
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </b-col>
            </div> -->
            <div class="row">
              <b-col md="12">
                <b-form-group
                  label="Chi tiết:"
                  label-for="detail"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  content-cols="10"
                  id="editor-css"
                >
                  <div class="col-md-10 no-padding">
                    <b-form-input
                      type="text"
                      style="display: none"
                      aria-describedby="codeFeedback"
                      v-model="product.detail"
                    >
                    </b-form-input>
                    <DocumentEditor
                      ref="doc"
                      v-model="product.detail"
                    ></DocumentEditor>
                  </div>
                </b-form-group>
              </b-col>
            </div>

            <b-row>
              <b-col>
                <b-form-group
                  label="Đường dẫn hình ảnh:"
                  label-for="urlImage"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  label-class="required"
                >
                  <b-form-file
                    v-model="$v.product.files.$model"
                    class="col-10 no-padding"
                    accept="image/*"
                    browse-text="Chọn"
                    multiple
                    placeholder="Chọn tệp tải lên..."
                    :state="
                      $v.product.files.$dirty ? !$v.product.files.$error : null
                    "
                  >
                    <template slot="file-name" slot-scope="{ names }">
                      <b-badge variant="dark">{{ names[0] }}</b-badge>
                      <b-badge
                        v-if="names.length > 1"
                        variant="dark"
                        class="ml-1"
                      >
                        + {{ names.length - 1 }} tệp khác
                      </b-badge>
                    </template>
                  </b-form-file>
                  <b-form-invalid-feedback>
                    Vui lòng chọn tệp tải lên !
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Đường dẫn video:"
                  label-for="urlVideo"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                >
                  <b-form-input
                    type="text"
                    id="urlVideo"
                    class="col-10"
                    aria-describedby="urlVideoFeedback"
                    v-model="product.urlVideo"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Chủ đầu tư:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoInvestor"
                    class="col-10"
                    id="InfoInvestor"
                    rows="3"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Địa chỉ:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoAddress"
                    class="col-10"
                    id="infoAddress"
                    rows="3"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Diện tích:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoArea"
                    class="col-10"
                    id="infoArea"
                    rows="3"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Số tầng:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoFloorNumber"
                    class="col-10"
                    id="infoFloorNumber"
                    rows="3"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Số mặt tiền:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoFacadeNumber"
                    class="col-10"
                    id="infoAddress"
                    rows="3"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Gara:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoGarage"
                    class="col-10"
                    id="infoGarage"
                    rows="3"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Phong cách:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoStyle"
                    class="col-10"
                    id="infoStyle"
                    rows="3"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Thời gian thực hiện:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoExecutionDate"
                    class="col-10"
                    id="infoExecutionDate"
                    rows="3"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Đơn vị thiết kế:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoDesignUnit"
                    class="col-10"
                    id="infoDesignUnit"
                    rows="3"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Tổng thành tiền:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoTotalCost"
                    class="col-10"
                    id="infoTotalCost"
                    rows="3"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Công năng:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-textarea
                    v-model="product.infoPerformanceInfo"
                    class="col-10"
                    id="InfoPerformanceInfo"
                    rows="3"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="MetaTitle:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-textarea
                    v-model="$v.product.metaTitle.$model"
                    :state="
                      $v.product.metaTitle.$model && $v.product.metaTitle.$dirty
                        ? !$v.product.metaTitle.$error
                        : null
                    "
                    class="col-10"
                    id="MetaTitle"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    v-if="!$v.product.metaTitle.maxLength"
                  >
                    Không được quá 256 ký tự !
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="MetaKeywords:"
                  label-for="MetaKeywords"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-textarea
                    v-model="$v.product.metaKeywords.$model"
                    :state="
                      $v.product.metaKeywords.$model &&
                      $v.product.metaKeywords.$dirty
                        ? !$v.product.metaKeywords.$error
                        : null
                    "
                    class="col-10"
                    id="MetaKeywords"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    v-if="!$v.product.metaKeywords.maxLength"
                  >
                    Không được quá 256 ký tự !
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="MetaDescriptions:"
                  label-for="MetaDescriptions"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-textarea
                    v-model="$v.product.metaDescriptions.$model"
                    :state="
                      $v.product.metaDescriptions.$model &&
                      $v.product.metaDescriptions.$dirty
                        ? !$v.product.metaDescriptions.$error
                        : null
                    "
                    class="col-10"
                    id="MetaDescriptions"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    v-if="!$v.product.metaDescriptions.maxLength"
                  >
                    Không được quá 256 ký tự !
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Số lượng ảnh trình chiếu:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.numberSlider"
                    type="number"
                    class="col-10"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>


            <b-row>
              <b-col>
                <b-form-group
                  label="Trạng thái:"
                  label-align="right"
                  label-for="status"
                  :label-cols="2"
                  :horizontal="true"
                >
                  <b-form-checkbox
                    id="status"
                    v-model="product.status"
                    class="col-10 col-form-label"
                  ></b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Ưu tiên hiển thị:"
                  label-align="right"
                  label-for="isPrioritizeShow"
                  :label-cols="2"
                  :horizontal="true"
                >
                  <b-form-checkbox
                    id="isPrioritizeShow"
                    v-model="product.isPrioritizeShow"
                    class="col-10 col-form-label"
                  ></b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="" :label-cols="2">
                  <b-button
                    v-if="authorize(['ManageProduct'])"
                    type="submit"
                    variant="primary"
                    >Ghi lại</b-button
                  >
                  <b-button type="button" variant="secondary" @click="cancel"
                    >Hủy</b-button
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { authorizationMixin } from "@/shared/mixins";
import {
  required,
  sameAs,
  minLength,
  maxLength,
  helpers,
} from "vuelidate/lib/validators";

export default {
  name: "CreateProduct",
  mixins: [validationMixin, authorizationMixin],
  data() {
    return {
      codeUnique: "ok",
      product: {
        //name: null,
        title: null,
        code: null,
        description: null,
        detail: null,
        urlImage: null,
        categoryIds: [],
        slug: null,
        numberSlider: 4,
        infoInvestor: null,
        infoAddress: null,
        infoArea: null,
        infoFloorNumber: null,
        infoFacadeNumber: null,
        infoGarage: null,
        infoStyle: null,
        infoExecutionDate: null,
        infoDesignUnit: null,
        infoTotalCost: null,
        infoPerformanceInfo: null,

        metaTitle: null,
        metaKeywords: null,
        metaDescriptions: null,
        status: false,
        isPrioritizeShow: false,
        files: [],
        urlVideo: null,
      },
      editing: false,
    };
  },
  computed: {
    ...mapState({
      categories: (state, getters) => getters.categoryTree,
    }),
  },
  validations: {
    product: {
      //name: {
      //    required,
      //    maxLength: maxLength(128)
      //},
      title: {
        required,
      },
      description: {
        required,
      },
      // detail: {
      //   required,
      // },
      files: {
        required,
      },
      code: {
        required,
      },
      metaTitle: {
        maxLength: maxLength(256),
      },
      metaKeywords: {
        maxLength: maxLength(256),
      },
      metaDescriptions: {
        maxLength: maxLength(256),
      },
    },
  },
  watch: {
    //'product.code'(newVal) {
    //    this.checkExistCode(newVal);
    //}
    "product.title"(value) {
      this.product.slug = value.convertslug();
    },
  },
  created() {},
  mounted() {
    const element = document.getElementById("editor-css");
    element.querySelector(".bv-no-focus-ring").classList.add("col-md-10");
  },
  methods: {
    cancel() {
      this.$router.push({ path: "/master-data/products/list" });
    },
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var vm = this;
        this.$services
          .upload("master-data/products", this.product)
          .done((id) => {
            vm.$toastr.s("Tạo mới sản phẩm thành công");
            vm.cancel();
          });
      }
    },
    //checkExistCode(newVal) {
    //    if (newVal) {
    //        //var vm = this;
    //        //this.$services.get(`master-data/existing-unit-types-code/${newVal}/${this.product.id || null}`).done(returnData => {
    //        //    if (!returnData) {
    //        //        this.codeUnique = "required";
    //        //    }
    //        //    else {
    //        //        this.codeUnique = "";
    //        //    }
    //        //});
    //    }
    //    else {
    //        this.codeUnique = "required";
    //    }
    //}
  },
};
</script>
<style>
/*  .ck-editor__editable {
        min-height: 500px;
    }*/
.ck-editor .ck-editor__main .ck-content {
  min-height: 200px;
}

.ck-editor__editable_inline {
  min-height: 200px;
}
.no-padding! > div {
  width: 50%;
}
#editor-css .form-row {
  flex-direction: row-reverse;
}
</style>
